import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  postCreateDelegateGuestCall,
  getDelegatesCall,
  deleteDelegateCall,
  postDelegateActivationEmailCall,
  getOrganizationCreditsCall,
  getOrganizationCreditsQuarterCall,
  postCreateDelegateEmployerCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  postCreateDelegateGuestCall.saga,
  getDelegatesCall.saga,
  deleteDelegateCall.saga,
  postDelegateActivationEmailCall.saga,
  getOrganizationCreditsCall.saga,
  getOrganizationCreditsQuarterCall.saga,
  postCreateDelegateEmployerCall.saga,
];

export function* organizationSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
